import { Component, Input, Output, EventEmitter, inject, Inject, OnInit } from '@angular/core';
import { Api } from '../../services/api';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert.service';


interface modalData{
    tarea_id:string,
    estadoActual:string
}

@Component({
    standalone: true,
  selector: 'app-mdl-change-taskStatus',
  imports: [FormsModule,NgSelectModule,CommonModule],
  templateUrl: './mdl-change-taskStatus.html',
  styleUrls: ['./mdl-change-taskStatus.css']
})
export class MdlChangestatuscomponent implements OnInit {


    estados =[
        {value:'En progreso',label:'En progreso'},
        {value:'Pendiente',label:'Pendiente'},
        {value:'Vencida',label:'Vencida'},
        {value:'Completada',label:'Completada'}
    ]

      prioridades = [
    { label: 'Alta', value: 'Alta' },
    { label: 'Media', value: 'Media' },
    { label: 'Baja', value: 'Baja' }
    ];

    mode: 'estado' | 'prioridad';
    selectedEstado: string=''
    selectedPrioridad: string = '';

   
    constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alertService: AlertService,
    private mdl: MatDialogRef<MdlChangestatuscomponent>,
    private api: Api,
    
  ) {
    this.mode= data.mode
  }

  ngOnInit(): void {
      this.selectedEstado=this.data?.estadoActual || ''
  }

    closemodal(){
        this.mdl.close()
    }

 saveChanges() {
  const tareaId = this.data?.tarea_id;

  if (!tareaId) {
    this.alertService.error('Error', 'Falta tarea_id en los datos del modal');
    return;
  }

  if (this.mode === 'estado') {
    const estado = this.selectedEstado?.trim();
    if (!estado) {
      this.alertService.warning('Selecciona un estado', 'Debes seleccionar un estado');
      return;
    }

    this.api.updateTaskStatus({ tarea_id: tareaId, estado }).subscribe({
      next: () => {
        this.alertService.success('Estado actualizado', 'El estado se actualizó correctamente');
        this.mdl.close(true);
      },
      error: (err) => {
        console.error(err);
        this.alertService.error('Error al actualizar estado', 'No se pudo actualizar el estado');
      },
    });
  }

  if (this.mode === 'prioridad') {
    const prioridad = this.selectedPrioridad?.trim();
    if (!prioridad) {
      this.alertService.warning('Selecciona una prioridad', 'Debes seleccionar una prioridad');
      return;
    }

    this.api.updateTaskPriority({ tarea_id: tareaId, prioridad }).subscribe({
      next: () => {
        this.alertService.success('Prioridad actualizada', 'La prioridad se actualizó correctamente');
        this.mdl.close(true);
      },
      error: (err) => {
        console.error(err);
        this.alertService.error('Error al actualizar prioridad', 'No se pudo actualizar la prioridad');
      },
    });
  }
}

}







